import { render, staticRenderFns } from "./VxSidebarItem.vue?vue&type=template&id=f69c7d4a"
import script from "./VxSidebarItem.vue?vue&type=script&lang=js"
export * from "./VxSidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports